import React from 'react';

import { getSchoolStudents } from 'store/students/actions';

import { getTranslation } from 'helpers/getTranslation';

import { Loading } from 'components/shared/Loading';

import { StudentsTable } from 'components/StudentsTable';
import { EmptyState } from 'components/EmptyState';

import { getStudentsTableColumns } from './Students.tableConfig';

import styles from './Students.module.scss';

const Students = ({
  loading,
  students,
  schoolId,
  sortParams,
  onSortChange,
  onEditStudentClick,
  onStudentRowClick,
}: {
  loading: any;
  students: any;
  schoolId: string;
  sortParams: any;
  onSortChange: any;
  onEditStudentClick: any;
  onStudentRowClick: any;
}) =>
  loading ? (
    <Loading />
  ) : students && students.length > 0 ? (
    <StudentsTable
      columns={getStudentsTableColumns()}
      data={students}
      dataAction={({
        page,
        limit,
        sortBy,
        sortDirection,
      }: {
        page: any;
        limit: any;
        sortBy: any;
        sortDirection: any;
      }) =>
        getSchoolStudents({
          schoolId,
          params: { page, limit, sortBy, sortDirection },
        })
      }
      params={sortParams}
      onSortChange={onSortChange}
      onEditStudentClick={onEditStudentClick}
      onStudentRowClick={onStudentRowClick}
    />
  ) : (
    <EmptyState
      className={styles.emptyState}
      icon="student"
      title={getTranslation('school_page.students.empty_state.title')}
      text={getTranslation('school_page.students.empty_state.text')}
    />
  );

export default React.memo(Students) as any;
